var heading_default = {
  "fontElementMap": "vjqnZ",
  "elementSpacing": "IIY9t",
  "headerOne": "K9lCg IIY9t",
  "headerTwo": "Lqf70 IIY9t",
  "headerThree": "_0A6R9 IIY9t",
  "headerFour": "peyEB IIY9t",
  "headerFive": "oX-Ys IIY9t",
  "headerSix": "eEew- IIY9t",
  "child": "hyLB2"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
